<div class="container mx-0 mx-sm-auto m-t-80 m-b-100 px-0 px-sm-7">
  <div class="row justify-content-center">
    <!-- Left Column -->
    <div class="col-md-7 px-sm-5" *ngIf="portalName && portalName === 'cor1'">
      <h1
        class="mb-8 mx-6"
        [innerHTML]="'COR1_SIGNUP_SUCCESS.HEADER' | translate | safeHtml"
      ></h1>
      <div class="content-box">
        <h1
          class="mb-8"
          [innerHTML]="
            'COR1_SIGNUP_SUCCESS.YOUR_ACCOUNT_INFO_HEADER'
              | translate
              | safeHtml
          "
        ></h1>
        <p class="text-cool-gray-11c" id="cor1-success-name">
          {{ user['user_metadata']?.first_name }}
          {{ user['user_metadata']?.last_name }}
        </p>
        <p class="text-cool-gray-11c" id="cor1-success-email">
          {{ user.email }}
        </p>
      </div>
      <div class="content-box">
        <h3
          class="mb-8"
          [innerHTML]="
            'COR1_SIGNUP_SUCCESS.NEXT_STEPS_HEADER' | translate | safeHtml
          "
        ></h3>
        <p
          class="mb-8"
          [innerHTML]="
            'COR1_SIGNUP_SUCCESS.NEXT_STEPS_CONTENT1' | translate | safeHtml
          "
        ></p>
        <p
          class="mb-8"
          [innerHTML]="
            'COR1_SIGNUP_SUCCESS.NEXT_STEPS_CONTENT2' | translate | safeHtml
          "
        ></p>
        <p class="mb-8">
          {{ 'COR1_SIGNUP_SUCCESS.NEXT_STEPS_CONTENT3a' | translate }}
          <a (click)="goToAppSwitcher()" class="link">
            {{ 'COR1_SIGNUP_SUCCESS.NEXT_STEPS_ANCHOR_TEXT' | translate }}</a
          >
          {{ 'COR1_SIGNUP_SUCCESS.NEXT_STEPS_CONTENT3b' | translate }}
        </p>
        <p
          class="mb-8"
          [innerHTML]="
            'COR1_SIGNUP_SUCCESS.NEXT_STEPS_CONTENT4' | translate | safeHtml
          "
        ></p>
      </div>
    </div>
    <div class="col-md-7 px-sm-5" *ngIf="portalName && portalName === 'cor2'">
      <h1
        class="mb-8 mx-6"
        [innerHTML]="'COR2_SIGNUP_SUCCESS.HEADER' | translate | safeHtml"
      ></h1>
      <div class="content-box">
        <h1
          class="mb-8"
          [innerHTML]="
            'COR2_SIGNUP_SUCCESS.YOUR_ACCOUNT_INFO_HEADER'
              | translate
              | safeHtml
          "
        ></h1>
        <p class="text-cool-gray-11c" id="cor2-success-name">
          {{ user['user_metadata']?.first_name }}
          {{ user['user_metadata']?.last_name }}
        </p>
        <p class="text-cool-gray-11c" id="cor2-success-email">
          {{ user.email }}
        </p>
      </div>
      <div class="content-box">
        <h3
          class="mb-8"
          [innerHTML]="
            'COR2_SIGNUP_SUCCESS.NEXT_STEPS_HEADER' | translate | safeHtml
          "
        ></h3>
        <p
          class="mb-8"
          [innerHTML]="
            'COR2_SIGNUP_SUCCESS.NEXT_STEPS_CONTENT1' | translate | safeHtml
          "
        ></p>
        <p
          class="mb-8"
          [innerHTML]="
            'COR2_SIGNUP_SUCCESS.NEXT_STEPS_CONTENT2' | translate | safeHtml
          "
        ></p>
        <p class="mb-8">
          {{ 'COR2_SIGNUP_SUCCESS.NEXT_STEPS_CONTENT3a' | translate }}
          <a (click)="goToAppSwitcher()" class="link">
            {{ 'COR2_SIGNUP_SUCCESS.NEXT_STEPS_ANCHOR_TEXT' | translate }}</a
          >
          {{ 'COR2_SIGNUP_SUCCESS.NEXT_STEPS_CONTENT3b' | translate }}
        </p>
        <p
          class="mb-8"
          [innerHTML]="
            'COR2_SIGNUP_SUCCESS.NEXT_STEPS_CONTENT4' | translate | safeHtml
          "
        ></p>
      </div>
    </div>
  </div>
</div>
